module.exports = __webpack_public_path__ + "static/table1-a89de4d403e3b99d484fbb5bf5ce27c6.jpg";